export const styles = ({
    container: {
        minHeight: 15,
        fontStyle: 'italic',
        fontSize: 13,
        color: '#fff',
        fill: 'currentColor'
    }
});
